import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true; // synchronous ref guard: session_id is single-use, StrictMode mounts effects twice
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        window.history.replaceState(null, "", "/");
        setUser(data);
        toast.success(`Welcome back, ${data.name}`);
        navigate("/", { replace: true, state: { user: data } });
      } catch (err) {
        window.history.replaceState(null, "", "/login");
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center bg-background" data-testid="auth-callback">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}
